import React from "react";
import _, { forEach } from "lodash";
import classnames from "classnames";
import { Select } from "../Inputs";
import QuanitityInput from "../quanitity-input";
import a from "indefinite";
import MobileDetect from "mobile-detect";
import {
  setParams,
  getParams,
  removeParams,
  navigateTo,
} from "../../utils/location";
import SelectedOptionBox from "../SelectedOptionBox";
import AppContainer from "../AppContainer";
import List from "../List";
import Card from "../Card";
import Loader from "../Loader";
import CouponBatches from "../coupon-batches";
import LocationPinIcon from "../icons/LocationPin.svg";
import Button from "../Button";
import TotalPrice from "../TotalPrice";
import OrderItem from "../OrderItem";
import LocationClosedMessage from "../LocationClosedMessage";
import ErrorBlock from "../ErrorBlock";
import EmptyStateBagIcon from "../icons/EmptyStateBag.svg";
import OrderCalendar from "../OrderCalendar";
import ChargeCardToggle from "../charge-card-toggle";
import PromoCode from "../PromoCode";
import moment from "../../utils/moment-timezone-with-data-2012-2022";
import { NOW } from "../../utils/constants";
import getPickupTimesTranslatedInSelectForm from "../../utils/getPickupTimesTranslatedInSelectForm";
import Image from "../image";
import getLocationClosedText from "../../utils/getLocationClosedText";
import { fireRemoveItemEvent } from "../../utils/gtm";
import { getAppMedia, mediaTypes } from "../../utils/media";

import TrashIcon from "../icons/Trash.svg";
import PlusIcon from "../icons/PlusWithCircle.svg";
import TableIcon from "../icons/Table.svg";
import PlateIcon from "../icons/Plate.svg";
import PencilIcon from "../icons/Pencil.svg";
import { Grid, Button as MuiButton, Collapse, LinearProgress } from "@material-ui/core";
import styles from "./index.module.scss";
import SelectInput from "../Inputs/Select";

const AVAILABLE_AMOUNT_TOO_LOW = "AVAILABLE_AMOUNT_TOO_LOW";
export default class CheckoutView extends React.Component {
  state = {
    openCalendar: false,
    checkoutClicked: false,
  };

  componentDidMount() {
    const {
      loadBranchAvailabiltyIfNeeded,
      resetEditItemMode,
      saveOrderIfNeeded,
      pageContext: { kioskMode },
      paymentViewMode,
      user,
    } = this.props;
    if (!this.props.currentBranch) {
      console.log(
        "selected location is not available anymore, redirecting to home",
      );
      navigateTo("/");
    }
    this.md = new MobileDetect(window.navigator.userAgent);

    if (!_.isEmpty(this.props.order.orderItems)) {
      if (this.props.order.editingItem) {
        resetEditItemMode();
      }
    }

    this.resetPickupTimeIfNotAvailable();

    loadBranchAvailabiltyIfNeeded();

    if (!kioskMode) {
      this.props.resetReorder();
    }

    this.selectInitialPickupTimeIfNow();

    if (user.loggedIn && !paymentViewMode && !kioskMode) {
      this.props.loadLoyaltyProfile();
    }

    saveOrderIfNeeded();
  }

  componentDidUpdate() {
    this.resetPickupTimeIfNotAvailable();

    this.props.saveOrderIfNeeded();
  }

  setPickupTime = (pickupTime) => {
    const {
      setPickupTime,
      currentBranch: { timeZoneStr },
    } = this.props;
    this.state.openCalendar && this.setState({ openCalendar: false });

    setPickupTime({ pickupTime, timeZoneStr });
  };

  updateItemQuantity = (itemIndex) => (count) => {
    this.props.updateItemQuantity({ itemIndex, count });
  };

  removeItem = (index) => {
    const {
      checkedoutOrderItems,
      pageContext: {
        business: { currency },
      },
    } = this.props;
    const item = checkedoutOrderItems[index];

    fireRemoveItemEvent({ ...item, currency });
    this.props.removeItem(index);
  };

  removeAll = () => {
    const {
      checkedoutOrderItems,
      pageContext: {
        business: { currency },
      },
    } = this.props;
    forEach(checkedoutOrderItems, (item) => {
      fireRemoveItemEvent({ ...item, currency });
    });
    this.props.removeAllItems();
  };

  resetPickupTimeIfNotAvailable = () => {
    const { order, pickupTimes, T, paymentViewMode } = this.props;

    if (pickupTimes.loading || paymentViewMode) {
      return;
    }

    const translatedPickupTimes = getPickupTimesTranslatedInSelectForm({
      pickupTimes,
      T,
    });

    const isPickupTimeChosen = Boolean(order.pickupTime);

    const isPickupTimeInRange = (pickupTime) =>
      _.includes(pickupTime, NOW)
        ? _.includes(_.head(pickupTimes.data), NOW)
        : Boolean(
            _.find(translatedPickupTimes, ({ value }) => pickupTime === value),
          );

    const shouldResetPickupTime =
      isPickupTimeChosen && !isPickupTimeInRange(order.pickupTime);

    if (shouldResetPickupTime) {
      this.setPickupTime(null);
    }
  };

  selectInitialPickupTimeIfNow = () => {
    const {
      selectedServingOption: { disableServingNow },
      paymentViewMode,
      pickupTimes,
    } = this.props;

    if (!paymentViewMode) {
      const isAvailableNow =
        !_.isEmpty(pickupTimes.data) &&
        _.includes(_.head(pickupTimes.data), NOW);
      // set pickupTime to Now if null (once when enter from find location)
      if (
        isAvailableNow &&
        !disableServingNow &&
        !this.props.order.pickupTime
      ) {
        console.log("forced updated pickup time to now");
        this.setPickupTime(NOW);
      } else if (
        !_.isEmpty(pickupTimes.data) &&
        this.props.order.pickupTime &&
        !_.includes(pickupTimes.data, this.props.order.pickupTime)
      ) {
        console.warn("forced updated pickup time to:", pickupTimes.data[0]);
        this.setPickupTime(pickupTimes.data[0]);
      }
    }
  };

  handleCheckout = () => {
    const {
      pageContext: { kioskMode, businessAppConfiguration },
      location,
      user,
      openAuthModal,
    } = this.props;

    const { requireLoginForOrder } = businessAppConfiguration;
    if (requireLoginForOrder && !user.loggedIn) {
      openAuthModal();
    } else {
      if (this.props.location.pathname.startsWith("/order")) {
        this.setState({ checkoutClicked: true }, () =>
          _.defer(() =>
            navigateTo(
              kioskMode
                ? setParams("/kiosk-pay", getParams(location))
                : setParams("/payment", this.params),
            ),
          ),
        );
      }
    }
  };

  editItem = (itemIndex, itemId) => {
    const editableItem = this.props.order.orderItems[itemIndex];
    const targetItemId = editableItem.sourceItem
      ? editableItem.sourceItem.id
      : itemId;
    this.props.paymentViewMode && this.props.editItemFromPayment();
    this.props.startOrderItemEdit(
      itemIndex,
      targetItemId,
      this.props.pageContext.menuData,
    );
    navigateTo(
      setParams(`/order/items/${targetItemId}`, {
        ...this.params,
        editMode: true,
        itemName: editableItem.sourceItem ? editableItem.sourceItem.name : "",
      }),
    );
  };

  handleDaySelected = (selectedDate, { disabled }) => {
    const {
      setFutureServingTime,
      currentBranch: { timeZoneStr, id },
    } = this.props;
    this.setState({ openCalendar: false });
    if (disabled) {
      return;
    }
    setFutureServingTime({
      futureServingDate: selectedDate,
      timeZoneStr,
      branchId: id,
      props: this.props,
    });
  };

  rechargeCard = () =>
    navigateTo(
      setParams("/prepaid", {
        backPath: "/order",
        rechargeCard: "true",
        ...getParams(this.props.location),
      }),
    );

  shouldDisplayOptionToChargeCard = () => {
    const {
      canUserLoadChargeCard,
      userHasEnoughLoadedOnCardForOrder,
    } = this.props;

    return canUserLoadChargeCard && !userHasEnoughLoadedOnCardForOrder;
  };

  userHasFullGiftsDiscount = () => {
    const { priceDetails } = this.props;
    return !priceDetails.chargeCardDiscount && priceDetails.total === 0;
  };

  handleUpsellClicked = ({ itemToAdd, upsale }) => {
    navigateTo(
      setParams(`/order/items/${itemToAdd.menuItemId}`, {
        ...this.params,
        discountRuleId: upsale.discountDealId,
      }),
    );
  };

  render() {
    const {
      pageContext: {
        business: { currencySymbol, name },
        kioskMode,
        businessAppConfiguration,
        menuMultipliers: multipliers,
      },
      appStyles,
      app: { isSSR, keyboardOpen, kioskLocationId },
      location,
      user,
      order,
      checkedoutOrderItems,
      discountItems,
      hasCouponsForCheckout,
      selectedServingOption,
      currentBranch,
      priceDetails,
      sidebarMode,
      paymentViewMode,
      locations: { deliveryOptions },
      orderValidationErrors: { errorsByItemIndex, generalErrors },
      upsales,
      pickupTimes,
      isSavingOrder,
      T,
      hideWarningMessage,
      branchesAvailability,
      hasChargeCard,
      canUserLoadChargeCard,
      hasChargeCardDiscount,
      rechargeCardBenefitPrices,
      currentBranchOpeningTime,
      userHasEnoughLoadedOnCardForOrder,
      addPromoCode,
      removePromoCode,
    } = this.props;

    const defaultItemImage = getAppMedia(
      mediaTypes.defaultItemImage,
      appStyles,
    );

    const NoImageRenderer = defaultItemImage
      ? () => (
          <Image
            mediaKey={defaultItemImage.imageKey}
            mediaType={mediaTypes.defaultItemImage}
            imagePreview={defaultItemImage.imagePreview}
            sizes="400px"
            wrapperStyle={{ width: 90, height: 90 }}
            imgStyle={{ objectFit: "contain" }}
          />
        )
      : PlateIcon;

    const { loggedIn } = user;
    const { EmptyBag = {} } = appStyles;
    const { promoCodesEnabled } = businessAppConfiguration;

    this.params = getParams(location);

    const changeTargetURL = kioskMode
      ? `/kiosk/${kioskLocationId}`
      : setParams("/find-location", this.params);

    const currentBranchId = _.get(currentBranch, "id");

    const shouldDisplayDeliveryTip =
      _.get(selectedServingOption, "needsAddress") &&
      _.get(businessAppConfiguration, "offersDeliveryTip") &&
      !_.get(currentBranch.disableDeliveryTip);

    const shouldDisplayServiceOptionTip =
      selectedServingOption.offersTip &&
      !_.includes(
        _.get(currentBranch, "tipDisabledServingOptionTypes"),
        selectedServingOption.type,
      );

    const isPickup = selectedServingOption.type === "pickup";

    const offersPickupTime =
      selectedServingOption && selectedServingOption.offersPickupTime;

    const enableFutureOrders =
      currentBranch &&
      !currentBranch.disableFutureOrders &&
      selectedServingOption.enableFutureOrders;

    const shouldShowWarningMessage =
      !isSSR && !pickupTimes.loading && pickupTimes.status !== "AVAILABLE_NOW";

    const pickupTimesInSelectForm = getPickupTimesTranslatedInSelectForm({
      pickupTimes,
      T,
    });

    const mustSelectPickupTimeForFutureOrdering =
      enableFutureOrders &&
      !_.includes(order.pickupTime, NOW) &&
      moment(order.futureServingTime).dayOfYear() !==
        moment.tz(currentBranch.timeZoneStr).dayOfYear() &&
      !_.find(pickupTimesInSelectForm, { label: order.pickupTime });

    const mustSelectPickupTime =
      shouldShowWarningMessage && !order.pickupTime && offersPickupTime;

    const isBranchNotAvailable =
      pickupTimes.error &&
      pickupTimes.error === "BRANCH_AVAILABILITY_NOT_FOUND";

    let minimumDeliveryFee = 0;

    if (
      currentBranchId &&
      selectedServingOption.needsAddress &&
      !_.isEmpty(deliveryOptions)
    ) {
      const currentLocation = _.find(deliveryOptions, {
        branchId: currentBranchId,
      });
      if (currentLocation) {
        minimumDeliveryFee = currentLocation.minimumOrderAmount;
      }
    }

    const showMinimumDeliveryFeeError =
      (!_.isEmpty(generalErrors) &&
        _.find(generalErrors, {
          deliveryAvailability: "AVAILABLE_AMOUNT_TOO_LOW",
        })) ||
      (selectedServingOption.needsAddress &&
        minimumDeliveryFee > 0 &&
        minimumDeliveryFee >
          priceDetails.subtotal - (priceDetails.totalDiscount || 0));

    const hasErrors =
      mustSelectPickupTime ||
      (errorsByItemIndex && generalErrors) ||
      showMinimumDeliveryFeeError
        ? _.keys(errorsByItemIndex).length > 0 ||
          generalErrors.length > 0 ||
          isBranchNotAvailable ||
          mustSelectPickupTimeForFutureOrdering ||
          showMinimumDeliveryFeeError
        : false;

    const passedMaxOrderPrice = Boolean(
      _.find(generalErrors, {
        orderValidationWarning:
          "Price is passed the maximum allowed price for order",
      }),
    );

    const chargeCardDiscountChosen =
      hasChargeCardDiscount && !order.isChargeCardDeselected;
    const branchAvailability = _.get(branchesAvailability, currentBranchId);

    const defaultMenuMultiplierIndex = Array.isArray(multipliers)
      ? _.findIndex(multipliers, { defaultMultiplier: true })
      : 0;
    const hasLocationClosedError = _.find(
      generalErrors,
      (error) => error.orderValidationWarning === "Location is closed",
    );
    const locationClosed = hasLocationClosedError || shouldShowWarningMessage;
    const locationClosedText =
      locationClosed &&
      getLocationClosedText({
        T,
        locale: appStyles.locale,
        servingOptionTag: selectedServingOption.servingOptionTag,
        availableFrom: _.get(branchAvailability, "availableFrom"),
        closedMessage: _.get(branchAvailability, "closedMessage"),
        timeZoneStr: currentBranch.timeZoneStr,
        servingOptionType: selectedServingOption.type,
      });

    const chargeCardBalance =
      _.get(
        user,
        "loyaltyProfile.data.openChargeCardInstance.loadedAmount",
        0,
      ) -
      _.get(user, "loyaltyProfile.data.openChargeCardInstance.usedAmount", 0);
    const itemImageWrapperStyle = {
      ...(appStyles.rtl ? { marginLeft: 10 } : { marginRight: 10 }),
      borderRadius: appStyles.cardBorderRadius,
    };

    return (
      <AppContainer.Content
        tightBottom
        style={{
          minHeight: "calc(100vh - 60px)",
          direction: appStyles.rtl ? "rtl" : "ltr",
          ...(appStyles.checkoutBackgroundColor &&
            this.props.sidebarMode && {
              background: appStyles.checkoutBackgroundColor,
            }),
        }}
        appStyles={appStyles}
        sidebarMode={this.props.sidebarMode}
      >
        {Boolean(
          order.orderItems.length &&
            (shouldShowWarningMessage || generalErrors.length > 0) &&
            !isSavingOrder,
        ) && (
          <ErrorBlock
            warning={selectedServingOption.offersPickupTime}
            appStyles={appStyles}
            classNames={classnames(
              sidebarMode &&
                hideWarningMessage &&
                _.isEmpty(generalErrors) &&
                styles.HideOnDesktop,
              paymentViewMode && styles.ErrorBlockPaymentMode,
            )}
          >
            {locationClosed && _.isEmpty(generalErrors) ? (
              <LocationClosedMessage
                isBranchNotAvailable={isBranchNotAvailable}
                branch={currentBranch.name}
                pickupTimes={pickupTimes}
                appStyles={appStyles}
                onRetryClicked={
                  isBranchNotAvailable
                    ? () => navigateTo("/find-location")
                    : this.props.loadBranchAvailabiltyIfNeeded
                }
                hasDelayedOrder={selectedServingOption.offersPickupTime}
                T={T}
                currentBranchOpeningTime={currentBranchOpeningTime}
                locationClosedMessage={locationClosedText}
                selectedServingOptionType={selectedServingOption.type}
              />
            ) : (
              generalErrors.length > 0 &&
              _.map(generalErrors, (error, index) => (
                <div key={index} style={{ margin: "0 5px 0 5px" }}>
                  {error.deliveryAvailability === AVAILABLE_AMOUNT_TOO_LOW
                    ? `${T(
                        "Minimum order amount is ",
                      )}${currencySymbol}${(() => {
                        const branch = _.find(
                          deliveryOptions,
                          (branch) => branch.branchId === currentBranch.id,
                        );
                        if (branch && _.isNumber(branch.minimumOrderAmount)) {
                          return branch.minimumOrderAmount.toFixed(2);
                        }
                        return "higher than current total.";
                      })()}`
                    : T(error.orderValidationWarning)}
                </div>
              ))
            )}
          </ErrorBlock>
        )}
        <div className={classnames(paymentViewMode && styles.HideOnDesktop)}>
          <SelectedOptionBox
            title={T(selectedServingOption.servingOptionTag)}
            itemLabel={
              !kioskMode &&
              (selectedServingOption.needsAddress
                ? `${T("To:")} `
                : `${isPickup ? T("From:") : T("at:")} `)
            }
            itemIconComponent={!kioskMode && LocationPinIcon}
            itemIconStyles={styles.IconComponent}
            itemValueRenderer={
              !kioskMode &&
              (selectedServingOption.needsAddress ? (
                order.deliveryAddress && order.deliveryAddress.description
              ) : (
                <span style={{ flex: "1 0 auto", fontSize: "1.2rem" }}>
                  <span>{_.get(currentBranch, "name")}</span>
                  <br />
                  <small>{_.get(currentBranch, "address")}</small>
                </span>
              ))
            }
            changeTargetURL={changeTargetURL}
            changeLabel={T("Change")}
            appStyles={appStyles}
          >
            {order.tableCode && (
              <div>
                <TableIcon className={styles.IconComponent} />
                {T("Table Chosen:")}{" "}
                <span style={{ fontWeight: "bold" }}>{order.tableCode}</span>
              </div>
            )}
            {enableFutureOrders && offersPickupTime && (
              <OrderCalendar
                T={T}
                appStyles={appStyles}
                servingOptionTag={selectedServingOption.servingOptionTag}
                openCalendar={this.state.openCalendar}
                onDaySelected={this.handleDaySelected}
                onInputClick={() =>
                  this.setState({ openCalendar: !this.state.openCalendar })
                }
                selectedDate={order.futureServingTime}
                branchAvailability={branchAvailability}
                timeZone={currentBranch.timeZoneStr}
              />
            )}
            {!isBranchNotAvailable && offersPickupTime && (
              <div style={{ marginTop: 10 }}>
                <div>
                  {T(`${selectedServingOption.servingOptionTag} ${T("Time")}`)}:
                </div>
                {pickupTimes.loading ? (
                  <LinearProgress
                    style={{
                      color: appStyles.accentColor,
                      margin: "20px 0",
                    }}
                  />
                ) : (
                  <SelectInput
                    appStyles={appStyles}
                    style={{ marginTop: 6, width: "100%" }}
                    onChange={this.setPickupTime}
                    value={
                      order.pickupTime === NOW
                        ? pickupTimesInSelectForm[0]?.value
                        : order.pickupTime
                    }
                    options={pickupTimesInSelectForm || []}
                    placeholder={
                      !order.pickupTime && T("Please Select a Time")
                    }
                  />
                )}
              </div>
            )}
            {!locationClosed &&
              !isBranchNotAvailable &&
              !offersPickupTime &&
              pickupTimes.firstPickupTimeDelay > 0 && (
                <div>
                  {T(
                    `${T(
                      `${T("Available for ")}${
                        selectedServingOption.servingOptionTag
                      } ${T("in")}`,
                    )} ${pickupTimes.firstPickupTimeDelay} ${T("minutes")}`,
                  )}
                </div>
              )}
          </SelectedOptionBox>
        </div>
        {promoCodesEnabled && (
          <PromoCode
            T={T}
            appStyles={appStyles}
            addPromoCode={addPromoCode}
            removePromoCode={removePromoCode}
            promoCodes={order.promoCodes}
            servingOptionTag={selectedServingOption.servingOptionTag}
            branch={currentBranch.name}
            wrap
            style={isSavingOrder ? { display: "none" } : {}}
          />
        )}
        {isSavingOrder ? (
          <AppContainer.CenteredColumn style={{ marginTop: "25%" }}>
            <Loader appStyles={appStyles} />
          </AppContainer.CenteredColumn>
        ) : Boolean(order.orderItems.length) ? (
          <div>
            {order.saveOrderError ? (
              <AppContainer.CenteredColumn style={{ marginTop: "45%" }}>
                <h4 style={{ color: appStyles.accentColor }}>
                  {T("Connection Error :(")}
                </h4>
                <Button
                  i
                  appStyles={appStyles}
                  onClick={() =>
                    this.props.saveOrderIfNeeded({
                      force: true,
                    })
                  }
                >
                  {T("Try Again")}
                </Button>
              </AppContainer.CenteredColumn>
            ) : (
              <div>
                <Collapse in={Boolean(checkedoutOrderItems.length)}>
                  <Card appStyles={appStyles}>
                    <List>
                      <Grid
                        container
                        justify="space-between"
                        alignItems="center"
                      >
                        <List.Item.Title appStyles={appStyles}>
                          {T("Order Details")}
                        </List.Item.Title>
                        <Grid item>
                          <MuiButton
                            size="small"
                            color="inherit"
                            className={styles.ClearAllButton}
                            onClick={this.removeAll}
                            endIcon={<TrashIcon />}
                          >
                            {T("Remove All")}
                          </MuiButton>
                        </Grid>
                      </Grid>

                      {_.map(checkedoutOrderItems || [], (item, itemIndex) => (
                        <OrderItem
                          noImageRenderer={NoImageRenderer}
                          appStyles={appStyles}
                          item={item}
                          key={itemIndex}
                          T={T}
                          multipliers={multipliers}
                          defaultMultiplierIndex={defaultMenuMultiplierIndex}
                          currencySymbol={currencySymbol}
                          posInnerMenuId={_.get(
                            currentBranch,
                            "innerPosMenuId",
                          )}
                          bottomBorder
                        >
                          <span
                            className={styles.ItemActionsWrapper}
                            style={{ color: appStyles.actionColor }}
                          >
                            <span
                              className={classnames(
                                styles.SmallQuantityInputWrapper,
                                appStyles.rtl && styles.RTL,
                                item.count ===
                                  (item.minimumRequiredCount || 1) &&
                                  styles.DisabledMinus,
                                item.count ===
                                  (item.maximumAllowedCount || 100) &&
                                  styles.DisabledPlus,
                              )}
                              style={{
                                borderRadius: appStyles.buttonBorderRadius,
                              }}
                            >
                              <QuanitityInput
                                small
                                value={item.count}
                                min={item.minimumRequiredCount || 1}
                                max={item.maximumAllowedCount || 100}
                                appStyles={appStyles}
                                T={T}
                                size="small"
                                onChange={_.debounce(
                                  this.updateItemQuantity(itemIndex),
                                  400,
                                )}
                              />
                            </span>
                            <span
                              style={{
                                display: "flex",
                                alignItems: "center",
                                flexGrow: 1,
                                justifyContent: "space-between",
                                maxWidth: 86,
                              }}
                            >
                              <PencilIcon
                                onClick={() =>
                                  this.editItem(itemIndex, item.menuItemId)
                                }
                                className={styles.Clickable}
                                role="button"
                                aria-label={T("EDIT")}
                              />
                              <TrashIcon
                                onClick={() => this.removeItem(itemIndex)}
                                className={styles.Clickable}
                                role="button"
                                aria-label={T("REMOVE")}
                              />
                            </span>
                          </span>
                          {errorsByItemIndex[itemIndex] && (
                            <span className={styles.ItemError}>
                              {T(
                                errorsByItemIndex[itemIndex].errorFormat ||
                                  errorsByItemIndex[itemIndex]
                                    .orderValidationWarning,
                                errorsByItemIndex[itemIndex].errorVars,
                              )}
                            </span>
                          )}
                        </OrderItem>
                      ))}
                      {_.map(discountItems || [], (item, index) => (
                        <List.Item bottomBorder tight key={index}>
                          <List.Item.Image
                            className={styles.ItemImage}
                            style={itemImageWrapperStyle}
                            mediaType={mediaTypes.deal}
                            mediaKey={_.get(item, "deal.imageKey")}
                            sizes={"90px"}
                            imagePreview={_.get(item, "deal.imagePreview")}
                            width={90}
                            height={90}
                            background="transparent"
                            imgStyle={
                              appStyles.orderItemImageFit && {
                                objectFit: appStyles.orderItemImageFit,
                              }
                            }
                            noImageRenderer={NoImageRenderer}
                          />
                          <List.Item.Content>
                            <List.Item.Title light>
                              <strong>{item.description}</strong>
                              {appStyles.rtl ? (
                                <strong
                                  style={{ color: appStyles.accentColor }}
                                >
                                  (
                                  {(isNaN(item.discountAmount) ||
                                  item.discountAmount === null
                                    ? 0
                                    : item.discountAmount
                                  ).toFixed(2)}
                                  {currencySymbol}
                                  -)
                                </strong>
                              ) : (
                                <strong
                                  style={{ color: appStyles.accentColor }}
                                >
                                  (-
                                  {currencySymbol}
                                  {(isNaN(item.discountAmount) ||
                                  item.discountAmount === null
                                    ? 0
                                    : item.discountAmount
                                  ).toFixed(2)}
                                  )
                                </strong>
                              )}
                            </List.Item.Title>
                          </List.Item.Content>
                        </List.Item>
                      ))}
                      {_.flatMap(upsales, (upsale) => {
                        return _.map(
                          _.uniqBy(upsale.itemsToAdd, "menuItemId"),
                          (itemToAdd) => (
                            <List.Item
                              bottomBorder
                              tight
                              key={itemToAdd.menuItemId}
                            >
                              <List.Item.Image
                                mediaType={mediaTypes.menuItem}
                                mediaKey={itemToAdd.imageKey}
                                sizes="90px"
                                imagePreview={itemToAdd.imagePreview}
                                className={styles.ItemImage}
                                wrapperStyle={itemImageWrapperStyle}
                                width={90}
                                height={90}
                                background="transparent"
                                imgStyle={
                                  appStyles.orderItemImageFit && {
                                    objectFit: appStyles.orderItemImageFit,
                                  }
                                }
                                noImageRenderer={NoImageRenderer}
                              />
                              <List.Item.Content>
                                <span className={styles.Upsale}>
                                  <strong
                                    style={paymentViewMode && { width: "70%" }}
                                  >
                                    {upsale.upsaleText ? (
                                      <span>{upsale.upsaleText}</span>
                                    ) : (
                                      <span>
                                        {`${T("Add")} `}
                                        {appStyles.locale === "he-IL"
                                          ? itemToAdd.itemName
                                          : a(itemToAdd.itemName)}
                                        {_.isNumber(upsale.additionalPrice) && (
                                          <span>
                                            {T(` ${T("for")} `)}
                                            {upsale.additionalPrice > 0 ? (
                                              <span
                                                style={{
                                                  color: appStyles.actionColor,
                                                }}
                                              >
                                                {currencySymbol}
                                                {upsale.additionalPrice.toFixed(
                                                  2,
                                                )}
                                              </span>
                                            ) : (
                                              T("Free")
                                            )}
                                          </span>
                                        )}
                                        ?
                                      </span>
                                    )}
                                  </strong>
                                  <Button
                                    style={
                                      appStyles.rtl
                                        ? { marginRight: 16 }
                                        : { marginLeft: 16 }
                                    }
                                    appStyles={appStyles}
                                    centered
                                    onClick={() =>
                                      this.handleUpsellClicked({
                                        upsale,
                                        itemToAdd,
                                      })
                                    }
                                  >
                                    {T("ADD")}
                                  </Button>
                                </span>
                              </List.Item.Content>
                            </List.Item>
                          ),
                        );
                      })}
                    </List>
                  </Card>
                </Collapse>
                {hasCouponsForCheckout && (
                  <CouponBatches
                    appStyles={appStyles}
                    currencySymbol={currencySymbol}
                    T={T}
                    couponsUncheckedByUser={order.couponsUncheckedByUser}
                    couponsCheckedByUser={order.couponsCheckedByUser}
                    couponsBatchIndex={order.couponsBatchIndex}
                    onChange={this.props.setCouponsChecked}
                    {...order.checkoutResponse.couponBatchesResponse}
                  />
                )}
                {loggedIn &&
                  hasChargeCard &&
                  hasChargeCardDiscount &&
                  !this.userHasFullGiftsDiscount() && (
                    <ChargeCardToggle
                      T={T}
                      appStyles={appStyles}
                      isChargeCardDeselected={order.isChargeCardDeselected}
                      setChargeCardDeselected={
                        this.props.setChargeCardDeselected
                      }
                      chargeCardBalance={chargeCardBalance}
                      currencySymbol={currencySymbol}
                      canUserLoadChargeCard={canUserLoadChargeCard}
                      businessName={name}
                    />
                  )}
                <Card appStyles={appStyles} style={{ paddingTop: "5px" }}>
                  <TotalPrice
                    appStyles={appStyles}
                    shouldDisplayDeliveryTip={
                      shouldDisplayDeliveryTip &&
                      !currentBranch.disableDeliveryTip
                    }
                    shouldDisplayServiceOptionTip={
                      shouldDisplayServiceOptionTip
                    }
                    priceDetails={priceDetails}
                    currencySymbol={currencySymbol}
                    T={T}
                    businessName={name}
                    canUserLoadChargeCard={canUserLoadChargeCard}
                    shouldDisplayOptionToChargeCard={
                      canUserLoadChargeCard && !hasChargeCardDiscount
                    }
                    chargeCardDetails={_.get(
                      user,
                      "loyaltyProfile.data.openChargeCardInstance.chargeCard.chargeCardExplanation",
                    )}
                    rechargeCard={this.rechargeCard}
                  />
                </Card>
              </div>
            )}
          </div>
        ) : (
          <div
            style={{
              ...EmptyBag,
              display: "flex",
              flexDirection: "column",
              textAlign: "center",
              margin: "64px 0",
            }}
          >
            <div className={styles.EmptyBagState}>
              <EmptyStateBagIcon style={{ height: 70, width: 70 }} />
            </div>
            {T("Your bag is empty")}
          </div>
        )}

        {!order.saveOrderError && !isSavingOrder && (
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              if (_.startsWith(this.props.location.pathname, "/order")) {
                this.props.closeCheckoutView();
                navigateTo(removeParams(this.props.location, "checkoutOpen"));
              } else {
                navigateTo(setParams("/order", this.params));
              }
            }}
            className={sidebarMode && styles.HideOnDesktop}
            role="button"
            aria-label={T("Hungry for more? See the menu")}
          >
            <Card
              appStyles={appStyles}
              classNames={styles.BackToMenuCard}
              style={{
                padding: 0,
                borderColor: appStyles.actionColor,
              }}
            >
              <Card.Content>
                <span
                  className={styles.BackToMenu}
                  style={{ color: appStyles.actionColor }}
                >
                  {sidebarMode && <PlusIcon />}
                  {T("Hungry for more? See the menu")}
                </span>
              </Card.Content>
            </Card>
          </a>
        )}

        {Boolean(
          !paymentViewMode && order.orderItems.length && !isSavingOrder,
        ) && (
          <AppContainer.Footer
            relativePosition={keyboardOpen}
            ref={(el) => {
              this.footer = el;
            }}
            appStyles={appStyles}
            classNames={classnames(
              this.shouldDisplayOptionToChargeCard() && styles.ChargeCardOption,
            )}
            transparentGradient={!appStyles.withoutFooterButtonGradient}
            sidebarMode={sidebarMode}
            center
          >
            <AppContainer.Footer.Button
              disabled={hasErrors}
              spread={!hasErrors}
              onClick={!hasErrors && this.handleCheckout}
              appStyles={appStyles}
              center={
                this.shouldDisplayOptionToChargeCard() ||
                (userHasEnoughLoadedOnCardForOrder &&
                  chargeCardDiscountChosen) ||
                this.userHasFullGiftsDiscount()
              }
              loading={this.state.checkoutClicked}
              style={
                this.shouldDisplayOptionToChargeCard() && {
                  background: "white",
                  color: appStyles.actionColor,
                  border: `2px solid ${appStyles.actionColor}`,
                }
              }
            >
              <span>
                {hasErrors
                  ? !kioskMode &&
                    (mustSelectPickupTime ||
                      mustSelectPickupTimeForFutureOrdering)
                    ? isBranchNotAvailable && !enableFutureOrders
                      ? T("Please choose a different location")
                      : selectedServingOption.needsAddress
                      ? T("Please select delivery time")
                      : T("Please select pickup time")
                    : passedMaxOrderPrice
                    ? T("You passed the max order price")
                    : showMinimumDeliveryFeeError
                    ? `${T(
                        "You have not reached the minimum amount for delivery of",
                      )} ${
                        _.isNumber(minimumDeliveryFee)
                          ? `${currencySymbol}${minimumDeliveryFee.toFixed(2)}`
                          : "selected location"
                      }`
                    : hasLocationClosedError
                    ? locationClosedText
                    : T("Please check your bag for errors")
                  : hasChargeCardDiscount
                  ? this.shouldDisplayOptionToChargeCard()
                    ? T("Checkout with no additional discount")
                    : order.isChargeCardDeselected
                    ? T("Checkout Now")
                    : userHasEnoughLoadedOnCardForOrder
                    ? T("Order Now")
                    : T("Amount Due")
                  : this.shouldDisplayOptionToChargeCard()
                  ? T("Checkout with no discount")
                  : T("Checkout Now")}
              </span>
              {!this.shouldDisplayOptionToChargeCard() &&
                !this.userHasFullGiftsDiscount() &&
                (!chargeCardDiscountChosen ||
                  (chargeCardDiscountChosen &&
                    !userHasEnoughLoadedOnCardForOrder)) &&
                !isSavingOrder &&
                !hasErrors &&
                priceDetails &&
                priceDetails.total > -1 && (
                  <span>
                    {isNaN(priceDetails.total)
                      ? ""
                      : `${currencySymbol}${priceDetails.total.toFixed(2)}`}
                  </span>
                )}
            </AppContainer.Footer.Button>
            {this.shouldDisplayOptionToChargeCard() &&
              !hasErrors &&
              rechargeCardBenefitPrices && (
                <AppContainer.Footer.Button
                  onClick={!hasErrors && this.rechargeCard}
                  appStyles={appStyles}
                  center
                  style={{ border: `2px solid transparent` }}
                >
                  <span>{`${T("Charge")} ${currencySymbol}${
                    rechargeCardBenefitPrices.amountToCharge
                  } ${T("and receive")} ${currencySymbol}${
                    rechargeCardBenefitPrices.benefit
                  } ${T("to spend on your order")}`}</span>
                </AppContainer.Footer.Button>
              )}
          </AppContainer.Footer>
        )}
      </AppContainer.Content>
    );
  }
}
